<template>
  <div class="g-box">
    <link rel="stylesheet" href="/css/L-02.css">
    <link rel="stylesheet" href="/css/select2.css">
    <link rel="stylesheet" href="/css/select2plus.css">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <div class="g-content">
      <h1 class="g-h-1 g-rainbow">{{ $t('Index.'+currentIndex) }}</h1>
      <div class="g-layout">
        <!--サイドバー-->
        <div class="g-layout_sidebar">
          <!--SP専用-->
          <nav class="g-sp">
            <Select2 v-model="currentIndex" :options="topindexList" :settings="{ minimumResultsForSearch: Infinity, width: '100%', containerCssClass: 'indexSelect', dropdownCssClass: 'indexDropdown' }">
            </Select2>
          </nav>
          <!--/SP専用-->
          <!--PC専用-->
          <nav class="g-pc">
            <ul class="g-units">
              <li v-for="index in indexList" :key="index.id">
                <a @click="setCurrentId(index.id)" class="g-btn g-btn-nav" :aria-current="[index.id == currentIndex ? 'page' : '']">{{ index.text }}<i class="g-i g-i-arrow" aria-hidden="true"></i></a>
              </li>
            </ul>
          </nav>
          <!--/PC専用-->
        </div>
        <!--/サイドバー-->
        <!--メインコンテンツ-->
        <main class="g-layout_main">
          <section>
            <template>
              <p class="g-unit">{{ $t("Index.select_below") }}</p>
              <div class="g-unit-xl">
                <!--SP専用-->
                <div class="g-sp">
                  <Select2 v-model="currentSub" :options="subindexList" :settings="{ minimumResultsForSearch: Infinity, width: '100%', containerCssClass: 'select50on', dropdownCssClass: 'dropdown50on' }">
                  </Select2>
                </div>
                <!--/SP専用-->
                <!--PC専用-->
                <div class="g-pc">
                  <ul class="index50on">
                    <li v-for="sub in subindexList" :key="sub.id">
                      <a @click="setCurrentSub(sub.id)" class="g-btn g-btn-alt" :aria-selected="[sub.id == currentSub ? 'true' : '']">{{ sub.text }}</a>
                    </li>
                  </ul>
                </div>
                <!--/PC専用-->
              </div>
            </template>
            <template v-if="currentSub">
              <section class="g-unit-xl">
                <h3 class="g-h-3 g-clearfix with-filter">{{ sub_name }}
                  <span><input v-model="filter_text" class="g-input" type="text" :placeholder="$t('Index.filter')"></span>
                </h3>
                <template v-if="items">
                  <ul class="g-list g-list-link">
                    <li v-for="item in items" :key="item.value"><a @click="searchObject(item.value)">{{ getLabel(item.value) }}</a>（{{ item.count }}）</li>
                  </ul>
                </template>
              </section>
            </template>
          </section>
        </main>
        <!--/メインコンテンツ-->
      </div>
    </div>
  </div>
</template>

<script>
import mainMixin from '@/mixins/mainMixin.js'
import i18n from '@/i18n.js'
import { Backend } from '@/ajax/Backend'
const Indices = Backend.get('indices')
const Tables = Backend.get('tables')
import Select2 from 'v-select2-component'
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  name: 'Index',
  mixins: [ mainMixin ],
  components: {
    Select2,
    breadcrumb
  },
  props: {
    indexList: { type: Array, required: true },
    id: { type: String, required: true }
  },
  data () {
    return {
      currentIndex: this.id,
      currentSub: '',
      index: {},
      filter_text: '',
      ocmListAll: {},
      owcListAll: {},
    }
  },
  filters: {
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/index'+this.currentIndex, text: 'Index.'+this.currentIndex },
      ]
    },
    // インデックス選択用一覧
    topindexList: function() {
      const indices = []
      if (this.indexList) {
        this.indexList.forEach(function (val) {
          indices.push({id: val.id, text: val.text})
        });
      }
      return indices
    },
    // サブインデックス選択用一覧
    subindexList: function() {
      const id = this.currentIndex
      if (id) {
        if (this.indexList.find(index => index.id == id)) {
          return this.indexList.find(index => index.id == id).children
        }
      }
      return []
    },
    // サブインデックスの名前表示用
    sub_name: function() {
      if (this.subindexList) {
        const csub = this.currentSub
        return this.subindexList.find(sub => sub.id == csub).text
      }
      return '-'
    },
    // APIから取得したインデックス項目の一覧
    items: function() {
      const items = []
      if (this.index) {
        Object.keys(this.index).forEach(function (key) {
          const exclude_items = ['__notset__']
          const label = this.getLabel(key)
          if (exclude_items.indexOf(key) < 0) {
            if (this.filter_text) {
              if (label.indexOf(this.filter_text) > -1) {
                items.push({"value": key, "count": this.index[key]})
              }
            } else {
              items.push({"value": key, "count": this.index[key]})
            }
          }
        }.bind(this));
      }
      return items
    },
    // OCMのラベル一覧
    ocmList () {
      if (i18n.locale == 'en') {
        return this.ocmListAll.en
      } else {
        return this.ocmListAll.ja
      }
    },
    // OWCのラベル一覧
    owcList () {
      if (i18n.locale == 'en') {
        return this.owcListAll.en
      } else {
        return this.owcListAll.ja
      }
    },
  },
  watch: {
    // インデックスを変更したらサブインデックスはクリア
    currentIndex: function() {
      if (i18n.locale == 'en') {
        this.$router.push('/en/index/'+this.currentIndex)
      } else {
        this.$router.push('/index/'+this.currentIndex)
      }
      this.currentSub = ''
    },
    // サブインデックスを選択したらインデックス項目をAPIから取得
    currentSub: function() {
      if (this.currentSub) {
        this.getIndex(this.currentIndex, this.currentSub)
      }
    }
  },
  mounted: function() {
    // OCM、OWCのラベル一覧の取得
    this.getOCMLabels()
    this.getOWCLabels()
    // 以前の条件を取得
    this.currentIndex = this.id
    setTimeout(
      function () {
        this.currentSub = this.$store.getters.index_db
        if (this.currentSub) {
          this.getIndex(this.currentIndex, this.currentSub)
        }
      }.bind(this),
      "500"
    );
  },
  methods: {
    // インデックスの選択
    setCurrentId(id) {
      this.currentIndex = id
    },
    // インデックスを選んだらヘッダーに名前を表示
    setCurrentSub(name) {
      this.currentSub = name
    },
    // ラベル情報を取得
    getLabel(id) {
      if (this.currentIndex == 'ocm') {
        return this.getLabelOCM(id)
      }
      if (this.currentIndex == 'owc') {
        return this.getLabelOWC(id)
      }
      return id
    },
    // OCMのラベル情報を取得
    getLabelOCM(id) {
      if (this.ocmList) {
        const label = this.ocmList[id]
        if (label) {
          return label
        } else {
          return id
        }
      } else {
        return id
      }
    },
    // OWCのラベル情報を取得
    getLabelOWC(id) {
      if (this.owcList) {
        const label = this.owcList[id]
        if (label) {
          return label
        } else {
          return id
        }
      } else {
        return id
      }
    },
    // インデックス情報取得（API）
    getIndex(field, db) {
      this.$store.commit('setIndexField', field)
      this.$store.commit('setIndexDb', db)
      Indices.get(field, db, i18n.locale)
        .then(function(response) {
          this.index = response.data
        }.bind(this))
        .catch(err => console.log(err))
    },
    // インデックスによる検索
    searchObject(value) {
      const request = {}
      request[this.currentIndex] = value
      request.exact_fields = this.currentIndex
      request.dbs = []
      request.dbs.push(this.currentSub)
      request.page = 1
      if (i18n.locale == 'en') {
        this.$router.push({ path: '/en/search', query: request })
      } else {
        this.$router.push({ path: '/search', query: request })
      }
    },
    // OCMラベル情報取得
    getOCMLabels() {
      Tables.get('ocm')
        .then(function(response) {
          this.ocmListAll = response.data
        }.bind(this))
        .catch(err => console.log(err))
    },
    // OWCラベル情報取得
    getOWCLabels() {
      Tables.get('owc')
        .then(function(response) {
          this.owcListAll = response.data
        }.bind(this))
        .catch(err => console.log(err))
    },
  },
  head: {
    title: function () {
      return {
        inner: i18n.t('Site.title') + ' ' + i18n.t('Index.'+this.currentIndex),
      }
    },
    meta: function () {
      return [
        { property: 'og:title', content: i18n.t('Site.title') + ' ' + i18n.t('Index.'+this.currentIndex) },
      ]
    }
  }
}
</script>
